var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-link',{attrs:{"underline":false},on:{"click":function($event){_vm.drawerVisible = true}}},[_c('i',{staticClass:"el-icon-brush"})]),_c('palette',{attrs:{"visible":_vm.drawerVisible},on:{"update:visible":function($event){_vm.drawerVisible=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }